import React, { Component } from 'react'
import get from 'lodash/get'
import InfoBlock from '../components/shared/infoBlock'
import Collapsable from '../components/shared/collapsable'
import AngleBracketButton from '../components/shared/angleBracketButton'
import { Desktop, Mobile, Tablet, isNarrowDesktop } from '../media-queries'
import GraphicCard from '../components/shared/graphicCard'
import Helmet from 'react-helmet'
import SideContainer from '../components/shared/sideContainer'
import Title from '../components/shared/title'

export default class ScholarshipsPage extends Component {
  state = {
    isNarrowDesktop: isNarrowDesktop(),
    sideContainerHeight: 0,
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.handleResize)
    }
    this.setState({ sideContainerHeight: this.getHeight() })
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleResize)
    }
  }

  handleResize = () => {
    if (this.state.isNarrowDesktop !== isNarrowDesktop()) {
      this.setState({ isNarrowDesktop: isNarrowDesktop() })
    }
    this.setState({ sideContainerHeight: this.getHeight() })
  }

  getHeight = () => {
    if (document && document.body) {
      return document.body.scrollHeight - 45 - 210
    }
  }

  render() {
    const [{ node: data }] = get(
      this,
      'props.data.allContentfulTuitionScholarshipsPage.edges'
    )
    return (
      <div
        style={{
          background: '#f7f7f7',
          fontFamily: "'Libre Franklin', 'sans serif'",
        }}
      >
        <Helmet
          title={'IMRD - Tuition & Scholarships'}
          meta={[
            { name: 'description', content: 'tuition and scholarships' },
            {
              name: 'keywords',
              content: 'IMRD, UGent, tuition, scholarships'.concat(
                data.scholarships.map(({ name }) => `, ${name}`)
              ),
            },
          ]}
        />
        <Desktop>
          <DesktopScholarshipsPage data={{ ...data, ...this.state }} />
        </Desktop>
        <Tablet>
          <TabletScholarshipsPage data={data} />
        </Tablet>
        <Mobile>
          <MobileScholarshipsPage data={data} />
        </Mobile>
      </div>
    )
  }
}

const DefaultScholarshipsPage = ({ data }) => (
  <div>
    <InfoBlock
      title={data.title}
      bigTitle={true}
      text={data.intro.internal.content}
    />
    <div
      style={{
        display: 'flex',
        padding: '1rem 0',
        marginLeft: '',
        margin: '2.5rem 0 2.5rem',
      }}
    >
      <AngleBracketButton
        text="Our programme"
        link="/programme"
        hasCaret={false}
        style={{
          background: '#8CBD8C',
        }}
      />
      <AngleBracketButton
        text="IMRD Administration"
        link="/contact"
        style={{
          width: '250px',
          marginLeft: '2rem',
        }}
      />
    </div>
    <Title style={{ fontSize: '16px' }} title={'Tuition'} />
    <InfoBlock text={data.aboutTuitionFees.internal.content} />
  </div>
)

const DesktopScholarshipsPage = ({ data }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
    }}
  >
    <SideContainer
      minusHeight={2.5 * 18}
      style={{
        padding: '2rem 17.5vw 2rem 5rem',
        width: '67vw',
      }}
    >
      <DefaultScholarshipsPage data={data} />
    </SideContainer>
    <div
      style={{
        width: '33vw',
        background: '#8CBD8C',
      }}
    >
      <div
        className={'scrollable'}
        style={{
          maxHeight: data.sideContainerHeight,
          padding: data.isNarrowDesktop ? '2rem 1rem 1rem' : '2rem 2rem 1rem',
        }}
        hidden={data.sideContainerHeight === 0}
      >
        <InfoBlock
          title={'IMRD Scholarships'}
          style={{ paddingBottom: '1rem' }}
        />
        {data.scholarships.map(({ image, url, name, text }, i) => (
          <div style={{ marginBottom: '0.5rem', width: '100%' }} key={i}>
            <GraphicCard
              route={url}
              title={name}
              text={text.internal.content}
              style={{
                lineHeight: '1.25',
                fontSize: '13px',
                padding: ' 1.5rem',
              }}
              scale={false}
              image={image}
              imageStyle={{
                width: '80%',
                height: 'auto',
              }}
            />
          </div>
        ))}
      </div>
    </div>
  </div>
)
const TabletScholarshipsPage = ({ data }) => (
  <div
    style={{
      padding: '2rem 4rem 0',
    }}
  >
    <DefaultScholarshipsPage data={data} />
    <div
      style={{
        background:
          'linear-gradient(to bottom, #f7f7f7, #f7f7f7 2.5rem, #8CBD8C 2.5rem, #8CBD8C)',
        padding: '1rem 4rem 2rem',
        margin: '2rem -4rem 0',
      }}
    >
      <Collapsable text="View our scholarships">
        <div>
          {data.scholarships.map(({ image, url, name, text }, i) => (
            <div style={{ marginBottom: '0.5rem' }} key={i}>
              <GraphicCard
                route={url}
                title={name}
                text={text.internal.content}
                style={{
                  fontSize: '14px',
                  padding: ' 1.5rem',
                }}
                image={image}
                imageStyle={{
                  width: '25vw',
                  marginTop: '1rem',
                  height: 'auto',
                }}
              />
            </div>
          ))}
        </div>
      </Collapsable>
    </div>
  </div>
)

const MobileScholarshipsPage = ({ data }) => (
  <div>
    <InfoBlock
      style={{
        padding: '1rem 2rem 3rem',
      }}
      title={data.title}
      text={data.intro.internal.content}
    />
    <InfoBlock
      text={data.aboutTuitionFees.internal.content}
      style={{ background: '#8CBD8C', padding: '1rem 2rem', margin: 0 }}
    />
    <div
      style={{
        marginTop: '-1px',
        background:
          'linear-gradient(to bottom, #8CBD8C, #8CBD8C 2.5rem, #f7f7f7 2.5rem, #f7f7f7)',
        padding: '1rem',
      }}
    >
      <Collapsable text="View our scholarships">
        <div>
          {data.scholarships.map(({ image, url, name, text }, i) => (
            <div style={{ marginBottom: '0.5rem' }} key={i}>
              <GraphicCard
                route={url}
                title={name}
                text={text.internal.content}
                image={image}
                imageStyle={{
                  width: '80%',
                  height: 'auto',
                }}
              />
            </div>
          ))}
        </div>
      </Collapsable>
      <AngleBracketButton
        text="Our programme"
        link="/programme"
        style={{
          marginTop: '2rem',
          marginBottom: '0.5rem',
          width: 'calc(100vw - 2rem)',
        }}
      />
      <AngleBracketButton
        text="Contact"
        link="/contact"
        style={{
          marginBottom: '0.5rem',
          width: 'calc(100vw - 2rem)',
        }}
      />
    </div>
  </div>
)

export const TuitionAndScholarshipsQuery = graphql`
  query TuitionAndScholarships {
    allContentfulTuitionScholarshipsPage {
      edges {
        node {
          title
          intro {
            internal {
              content
            }
          }
          aboutTuitionFees {
            internal {
              content
            }
          }
          scholarships {
            name
            text {
              internal {
                content
              }
            }
            image {
              sizes(maxWidth: 362) {
                ...GatsbyContentfulSizes
              }
            }
            url
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/tuition-and-scholarships.js